export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14699.0f3b42f4.jpg";